import axios from "axios";
import { API_URL } from "../utils/apiUtils";

export const getAccountDetailsService = async (page, rowsPerPage) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(
      `${API_URL}/accounts/get-account-details`,
      {
        params: { page: page + 1, limit: rowsPerPage },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to fetch History. Please try again."
    );
  }
};
export const CreateAccountDetailsService = async (
  type,
  id,
  amount,
  isCredit,
  image
) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.post(
      `${API_URL}/accounts/create-account-details`,
      { type, id, amount, isCredit, image },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Unable to fetch History. Please try again."
    );
  }
};
export const getAccountReportService = async (startDate, endDate) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/accounts/generate-report`, {
      params: {
        startDate,
        endDate,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching dashboard details"
    );
  }
};
export const getAccountReportTableService = async (
  startDate,
  endDate,
  page,
  limit,
  filter,
  agent,
  search
) => {
  try {
    console.log("ahahdgdsas", startDate, endDate, page, limit, filter, search);
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/accounts/generate-report-data`,
      {
        params: {
          startDate,
          endDate,
          page,
          limit,
          filter,
          agent,
          search,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching dashboard details"
    );
  }
};
